const AOS = require('aos');
const $ = require('jquery');
// const _ = require('lodash');

require('@popperjs/core');
require('bootstrap');
require('slick-carousel');
// require('magnific-popup'); 
// Uncomment as necessary

window.jQuery = $;

$(function () {
  loadAOS();
  initSliders();
  initGoogleMapping();
  containerFix();
  submenuOffset();
  heroOffset();
  formFilters();
  moveOrderTitle();

  // handler for the resize window event
  $(window).on("resize", function () {
    containerFix();
  });
  // handler for the scroll window event
  $(window).on("scroll", function () {
    checkWindowScroll();
    uncoverElements();
  });

  function moveOrderTitle() {
    // Find the #order_review_heading and #order_review elements
    var orderReviewHeading = $('#order_review_heading');
    var orderReview = $('#order_review');

    // Check if both elements exist
    if (orderReviewHeading.length > 0 && orderReview.length > 0) {
      // Move #order_review_heading inside #order_review
      orderReview.prepend(orderReviewHeading);
    }
  }

  // Function to change the shipping label text
  function updateShippingLabel() {
    $('.woocommerce-checkout-review-order tr.woocommerce-shipping-totals th').text('Shipping (inc vat)');
    $('.woocommerce-checkout-review-order tr.cart-subtotal th').text('Sub Total (exc vat)');
    $('.woocommerce-checkout-review-order tr.tax-total th').text('Vat (on goods)');
    $('.woocommerce-checkout-review-order tr.tax-rate th').text('Vat (on goods)');
  }

  // Run the function initially in case AJAX has already finished
  updateShippingLabel();

  // Listen for any AJAX completion on the document
  $(document).ajaxComplete(function(event, xhr, settings) {
    // Check if the AJAX call is related to checkout updates
    updateShippingLabel();
  });

  // Hub Content
  if($('#hub-content').length > 0) {
    $('body').addClass('body-overflow');
  };

  // Smooth scroll.
  $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .on("click", function (event) {
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        var offset = $("header").outerHeight();
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          event.preventDefault();
          $("html, body").animate(
            {
              scrollTop: target.offset().top - offset,
            },
            1000
          );
        }
      }
    });

  // Burger click
  $("#burger").click(function () {
    open = !open;
    toggleMenu(open);
    $('.submenu').removeClass('open');
  });

  // Active class.
  $("header .nav [href]").each(function () {
    if (this.href == window.location.href) {
      $(this).addClass("active");
    }
  });

  // Header Fix (If the header has a border inside keep the + 1 else remove it)
  function resizeLogic() {
    if ($('body').hasClass('logged-in')) {
      var heightHeader = $("header").outerHeight();
      var adminHeader = $("#wpadminbar").outerHeight();
      var heightFix = heightHeader + adminHeader;
    } else {
      var heightFix = $("header").outerHeight();
    }
    
    $('.header-fix').height(heightFix);
    $('.search-bar').css('top', heightFix + 'px');
    formFilters();
  }

  resizeLogic(); // on load
  $(window).resize(resizeLogic); // on window resize

  // Price toggle

  priceDisplay();

  function priceDisplay() {
    var priceType = $('.switch-container input');

    if (priceType.prop('checked')) {
      $('.in-bond').addClass('fw-bold');
      $('.retail').removeClass('fw-bold');
    } else {
      $('.in-bond').removeClass('fw-bold');
      $('.retail').addClass('fw-bold');
    }
  }

  $('.switch-container input').on('change', function() {
    priceDisplay();
  });  

  function priceTabs() {
    $('.variable-item-radio-input-wrapper input').each(function() {
      var value = $(this).val();
  
      if (value == 1) {
        $(this).closest('.variable-item-radio-input-wrapper').find('.variable-item-radio-value').html('<h4 class="mb-0 variation-radio-label">Bottle</h4>');
      } else {
        $(this).closest('.variable-item-radio-input-wrapper').find('.variable-item-radio-value').html('<h4 class="mb-0 variation-radio-label">Case of ' + value + '</h4>');
      }
    });
    
    $('.variable-item-radio-value-wrapper').contents().filter(function() {
      return this.nodeType === 3;
    }).remove();
  }  

  priceTabs();

  // Form Filters Mobile
  function formFilters() {
    if ($(window).width() < 992) {
      if ($('.filter-icon').length > 2) {
        $('.filter-icon:gt(3)').hide();
        $('.show-more').show();
      }
     
      $('.show-more').on('click', function(e) {
        e.preventDefault();
        // toggle elements with class .ty-compact-list that their index is bigger than 2
        $('.filter-icon:gt(3)').toggle();
        // change text of show more element just for demonstration purposes to this demo
        $(this).text() === 'Show More' ? $(this).text('Show Less') : $(this).text('Show More');
      });
    } else {
      $('.filter-icon:gt(3)').show();
      $('.show-more').hide();
    }
  }

 // Sort Filter
  $('#sort-ref').on('change', function() {
    var selected = $('#sort-ref').find(":selected").val();

    $('.sort-filter-hidden').val(selected);
    $('#product-filters').submit();
  });

  // Price toggle
  $('#price-toggle').on('change', function() {
    if ($(this).prop('checked')) {
      $('.price-toggle-hidden').val('on');
    } else {
      $('.price-toggle-hidden').val('off');
    }

    $('#product-filters').submit();
  });

   // Levels for select 

   $('.level_2').each(
    function(){
        $(this).text('- '+$(this).text());
    }
  );

  $('.level_3').each(
      function(){
          $(this).text('-- '+$(this).text());
      }
  );

  // Producers 

  $('.producer-pill').on('click', function(){

    $('.producer-pane').addClass('d-none');
    $('.producer-pane').removeClass('d-block');

    var current = $(this);
    var attr = $(this).attr('pill-target');

    $('#' + attr).addClass('d-block');
    $('#' + attr).removeClass('d-none');
  });

  // Single product delivery details button

  $('.show-more-btn').click(function () {
    $('.delivery-details').slideDown();
    $('.show-more-btn').addClass('d-none');
    $('.show-less-btn').addClass('d-flex');
  });

  $('.show-less-btn').click(function () {    
    $('.delivery-details').slideUp();
    $('.show-more-btn').removeClass('d-none');
    $('.show-less-btn').removeClass('d-flex');
  });

  // At a glance button

  $('.glance-btn').on('click', function () {
    var id = $(this).data("id");

    if(id === $('.glance-content-' + id).data("id")) {
      $('.glance-item').addClass('d-none');
      $('.glance-btn').removeClass('active');
      $('.glance-item').removeClass('d-flex');
      $('.glance-content-' + id).addClass('d-flex');
      $('.glance-content-' + id).removeClass('d-none');
      $(this).addClass('active');
    }
  });

  // Search btn

  $('.search-btn').on('click', function () {
    $('.search-bar').toggleClass('open');

    // Check if the search-bar now has the "open" class
    if ($('.search-bar').hasClass('open')) {
      // Focus on the input field
      $('.search-bar input[type="text"]').focus();
    }
  });

  // Submenu.
  $(".submenu-toggle").on("click", function () {
    var toggle = $(this);
    toggle.toggleClass("open");
    $(this).prev(".parent-item").toggleClass("open");
    var submenu = $(this).next(".submenu");
    submenu.addClass("open");
  });

  $(".back-btn").on("click", function() {
    var currentItem = $(this);
    var submenu = currentItem.closest(".submenu");
    submenu.removeClass("open");
  });

  $(document).on('click', '#nav-tabContent .nav-link', function(event){
    if(window.innerWidth <= 991) {
      event.preventDefault();
      var target = $('.taxonomy-content.active');
      var offset = 200;

      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - offset
        }, 500);
      }
    }
  }); 

  $.fn.isScrolledIntoView = function () {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
    var elemTop = $(this).offset().top;
    return elemTop <= docViewBottom && elemTop >= docViewTop;
  };

  function removeDiacritics(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  $('.search-input').on('input', function() {
    var searchTerm = removeDiacritics($(this).val().toLowerCase().trim());

    var $navItems = $(this)
      .closest('.taxonomy-container')
      .closest('.tab-pane')
      .find('.taxonomy-options .nav-item');

    if (searchTerm === '') {
      $navItems.show();
    } else {
      $navItems.each(function() {
        var navLinkText = removeDiacritics($(this).find('.nav-link').text().toLowerCase().trim());
        $(this).toggle(navLinkText.includes(searchTerm));
      });
    }
  });

  // Quantity controls using jQuery
  function updateQuantityAndURL(button, increment) {
    var quantityInput = button.closest('.quantity-controls').find('.quantity');
    var currentValue = parseInt(quantityInput.val());
  
    // Find the closest anchor element and get its href attribute
    var closestButton = button.closest('.variation-row').find('.add-to-cart');
    var currentURL = closestButton.attr('href');
    
    var newQuantity = currentValue + increment;
    
    if (newQuantity >= 1) {
      // Update the quantity input value
      quantityInput.val(newQuantity);
      
      // Update the quantity parameter in the URL
      var url = new URL(currentURL, window.location.origin);
      url.searchParams.set('quantity', newQuantity);
      
      // Set the updated URL back to the href attribute
      closestButton.attr('href', url.toString());
    }
  }  
  
  $('.quantity-controls').on('click', '.minus', function(e) {
    e.preventDefault();
    updateQuantityAndURL($(this), -1);
  });
  
  $('.quantity-controls').on('click', '.plus', function(e) {
    e.preventDefault();
    updateQuantityAndURL($(this), 1);
  }); 
});

/**
 * @description loads the AOS library after a set timeout
 */
let loadAOS = () => {
  setTimeout(() => {
    $("body").addClass("loaded");
    setTimeout(() => {
      AOS.init();
    }, 500);
  }, 1000);
};

/**
 * @description checks the scroll value of the window and adds a class to the header if the window is scrolled
 */
let checkWindowScroll = () => {
  let scroll = $(window).scrollTop();
  if (scroll > 0) {
    $("header").addClass("scroll");
  } else {
    $("header").removeClass("scroll");
  }
};

/**
 * @description function for fixing floating elements or page width elements with content to the conventional bootstrap container sizes
 */
let containerFix = () => {
  if ($(".container-fix").length) {
    let containerWidths = {
      576: 540,
      768: 720,
      992: 960,
      1200: 1140,
      1440: 1380,
    };

    let windowWidth = $(window).width();
    let containerWidth = 0;
    // let containerWidth = $(".container").width() + 32;

    for (const [key, value] of Object.entries(containerWidths)) {
      if (windowWidth >= key) {
        containerWidth = value;
      }
    }

    if (containerWidth == 0) {
      console.error("containerWidth = 0 in Global.js on line: 213");
      return;
    } else {
      containerWidth += 32; // account for the padding on a bs container
    }

    // now calculate the padding for the offset on the content
    var padding = (windowWidth - containerWidth) / 2 + 16;

    if (windowWidth >= 992) {
      $(".container-fix").each(function () {
        if ($(this).hasClass("odd")) {
          $(this).css("padding-right", padding + "px");
        } else if ($(this).hasClass("even")) {
          $(this).css("padding-left", padding + "px");
        }
      });
    } else if (windowWidth >= 576 && windowWidth <= 991) {
      $(".container-fix").each(function () {
        $(this).css("padding-left", padding + "px");
        $(this).css("padding-right", padding + "px");
      });
    } else {
      $(".container-fix").each(function () {
        $(this).css("padding-left", "16px");
        $(this).css("padding-right", "16px");
      });
    }
  }
};

/**
 *  @description affix appropriately css positioned elements (ie position = fixed || absolute) below the header banner
 */
let submenuOffset = () => {
  let headerHeight = $("#header").outerHeight();
  let dropdown = $(".simple-menu");
  let topstripHeight = 0;
  let scroll = $(document).scrollTop();

  if (scroll == 0) {
    dropdown.css("top", headerHeight + "px");
  } else if (scroll < topstripHeight) {
    dropdown.css("top", scroll + headerHeight + "px");
  } else {
    dropdown.css("top", headerHeight + "px");
  }
};

/**
 * @description offset elements labeled with the offset hero class by the height of the header
 */
let heroOffset = () => {
  let hero = $(".offset-hero");
  let header = $("header");

  if (hero.length && header.length) {
    let height = $(header).outerHeight();
    $(hero).css("margin-top", `${height}px`);
  }
};

/**
 * @description reveals hidden page elements
 */
let uncoverElements = () => {
  $(".uncover").each(function () {
    if ($(this).isScrolledIntoView() === true) {
      $(this).addClass("show");
    }
  });
};

/**
 * @description initialise the slick sliders for the page
 */
let initSliders = () => {
  // generic slider example
  // go to - https://kenwheeler.github.io/slick/ - for documentation
  $(".slider").slick({
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToScroll: 1,
    slidesToShow: 1,
  });

  $(".previous-event-slider").slick({
    dots: false,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><span><i class="fa-solid fa-chevron-right left-chev"></i><i class="fa-solid fa-chevron-right right-chev"></i></span></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><span><i class="fa-solid fa-chevron-left left-chev"></i><i class="fa-solid fa-chevron-left right-chev"></i></span></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: false,
    mobileFirst: true,
  });

  // slider arrow functionality
  // $('.slick-{arrow-name}.slick-prev').click(function () {
  //   $('.{carousel-name}').slick('slickPrev');
  // });
  // $('.slick-{arrow-name}.slick-next').click(function () {
  //   $('.{carousel-name}').slick('slickNext');
  // });
};

/**
 * @description handles opening and closing of the mobile menu on the site
 *
 * @param {*} open flag indicating whether or not the menu is in an open state
 */
var open = false;
let toggleMenu = (open) => {
  $("#burger").toggleClass("open", open);
  $("#navigation-mobile ul").toggleClass("open", open);
};

/**
 * @description centers the map on the current marker or in the center of all markers present
 *
 * @param {*} map the JSON map object being worked on
 */
let centerMap = (map) => {
  let bounds = new google.maps.LatLngBounds();
  $.each(map.markers, function (i, marker) {
    let latlng = new google.maps.LatLng(
      marker.position.lat(),
      marker.position.lng()
    );
    bounds.extend(latlng);
  });
  if (map.markers.length == 1) {
    map.setCenter(bounds.getCenter());
    map.setZoom(map.zoom);
  } else {
    map.fitBounds(bounds);
  }
};

/**
 * @description adds a new marker to the map being created
 *
 * @param {*} $marker the jQuery HTML marker to be added
 * @param {*} map the JSON map object to be operated on
 */
let addMarker = ($marker, map) => {
  let latlng = new google.maps.LatLng(
    $marker.attr("data-lat"),
    $marker.attr("data-lng")
  );
  let icon = {
    url: "" + $marker.attr("data-icon") + "",
    scaledSize: new google.maps.Size(48, 48),
  };
  let marker = new google.maps.Marker({
    icon: icon,
    map: map,
    position: latlng,
  });
  map.markers.push(marker);
  if ($marker.html()) {
    let infowindow = new google.maps.InfoWindow({
      content: $marker.html(),
    });
    google.maps.event.addListener(marker, "click", function () {
      infowindow.open(map, marker);
    });
  }
};

/**
 * @description creates a new map at the location of the jQuery element passed in
 *
 * @param {*} $el the jQuery element to create a map aroudn
 */
let newMap = ($el) => {
  let $markers = $el.find(".marker");
  let args = {
    center: new google.maps.LatLng(0, 0),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    zoom: 16,
  };
  let map = new google.maps.Map($el[0], args);
  map.markers = [];
  $markers.each(function () {
    addMarker($(this), map);
  });
  centerMap(map);
  return map;
};

/**
 * @description convenience function for running all code required to generate a single (or multiple) maps on a page
 */
let initGoogleMapping = () => {
  $(".map").each(function () {
    newMap($(this));
  });
};
